import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle,
    Label,
    Button
} from "reactstrap"
import { Preview } from '../../../../helpers/ui/FileInput'

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/penilaianService'

import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar"

import IndexBloc from '../Index/Blocs/DataTableBloc'

import { Link, } from "react-router-dom"

class DetailView extends Component {
    source
    indexBloc = new IndexBloc()

    constructor(props) {
        super(props)
        this.state = {
            detail: [],
            domicile: 0
        }
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.id
        }
        await this.indexBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadDetail()
    }


    componentDidMount = () => {
        this.setTokenAPI()

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response, domicile: result.data.response.penilaian_domicile })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

    }

    componentWillUnmount() {
        this.indexBloc.detailChannel?.unsubscribe()
    }

    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="penilaian"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={`?penilaian`}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Detail Penilaian</CardTitle>
                                    <hr />
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tahun Penilaian 
                                            </Label>
                                            <Label
                                                className="col-md-10 col-form-label"
                                            >
                                                {detail?.ratting_year}
                                            </Label>
                                        </Row>
                                        <Row className="mb-3"><Label className="col-md-2 col-form-label">Kesetiaan</Label><Label className="col-md-10 col-form-label">{detail?.ratting_loyalty}</Label></Row>
                                        <Row className="mb-3"><Label className="col-md-2 col-form-label">Prestasi</Label><Label className="col-md-10 col-form-label">{detail?.ratting_performance}</Label></Row>
                                        <Row className="mb-3"><Label className="col-md-2 col-form-label">Tanggung Jawab</Label><Label className="col-md-10 col-form-label">{detail?.ratting_responsibility}</Label></Row>
                                        <Row className="mb-3"><Label className="col-md-2 col-form-label">Ketaatan</Label><Label className="col-md-10 col-form-label">{detail?.ratting_obedience}</Label></Row>
                                        <Row className="mb-3"><Label className="col-md-2 col-form-label">Kejujuran</Label><Label className="col-md-10 col-form-label">{detail?.ratting_honesty}</Label></Row>
                                        <Row className="mb-3"><Label className="col-md-2 col-form-label">Kerjasama</Label><Label className="col-md-10 col-form-label">{detail?.ratting_cooperation}</Label></Row>
                                        <Row className="mb-3"><Label className="col-md-2 col-form-label">Prakarsa</Label><Label className="col-md-10 col-form-label">{detail?.ratting_initiative}</Label></Row>
                                        <Row className="mb-3"><Label className="col-md-2 col-form-label">Kepemimpinan</Label><Label className="col-md-10 col-form-label">{detail?.ratting_leadership}</Label></Row>
                                        <Row className="mb-3"><Label className="col-md-2 col-form-label">Jumlah</Label><Label className="col-md-10 col-form-label">{detail?.ratting_amount}</Label></Row>
                                        <Row className="mb-3"><Label className="col-md-2 col-form-label">Rata Rata</Label><Label className="col-md-10 col-form-label">{detail?.ratting_average}</Label></Row>
                                        <Row className="mb-3">
                                            <Col md="2"></Col>
                                            <Col md="6">
                                                <Link to="/kepegawaian/home.html?penilaian">
                                                    <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                            </Col>
                                        </Row>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }

}

export default DetailView
